import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Divider, Form, Message } from 'semantic-ui-react'
import Dialog from '~/components/Dialog'
import { PhaseContentWrapper } from '../style'
import { useFormContext, useWatch } from 'react-hook-form'
interface Props {
  isModalOpen: boolean
  handleClose: (submited?: boolean) => void
}

export const monthsArray = [
  { key: 1, label: '1 Monat' },
  { key: 2, label: '2 Monate' },
  { key: 3, label: '3 Monate' },
  { key: 4, label: '4 Monate' },
  { key: 5, label: '5 Monate' },
  { key: 6, label: '6 Monate' },
  { key: 7, label: '7 Monate' },
  { key: 8, label: '8 Monate' },
  { key: 9, label: '9 Monate' },
  { key: 10, label: '10 Monate' },
  { key: 11, label: '11 Monate' }
];

const defaultPhaseValue = {
  name: '',
  months: '',
  order: 1
}

const CreatePhasesModal: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { isModalOpen, handleClose } = props
  const { control, setValue } = useFormContext()

  const [phaseOneData, setPhaseOneData] = useState(defaultPhaseValue)
  const [phaseTwoData, setPhaseTwoData] = useState({ ...defaultPhaseValue, order: 2 })

  const watchFeedingPhases = useWatch({ control, name: 'feedingPhases' })

  useEffect(() => {
    if (isModalOpen && watchFeedingPhases?.length > 0) {
      setPhaseOneData({
        ...watchFeedingPhases[0]
      })
      setPhaseTwoData({
        ...watchFeedingPhases[1]
      })
    }
  }, [isModalOpen])

  function renderPhaseContent() {
    return <PhaseContentWrapper>
      <div className='row-phase'>
        <div className='title'>
          <label>{t('Phase 1')}</label>
          <Divider className='thicker-divider' />
        </div>
        <Form>
          <Form.Group widths={'equal'}>
            <Form.Input
              label={t('Name')}
              placeholder={t('Enter phase 1 name')}
              onChange={(_, data) => setPhaseOneData({
                ...phaseOneData,
                name: data.value
              })}
              value={phaseOneData.name}
            />
            <Form.Select
              label={t('Duration')}
              selectOnBlur={false}
              selection
              placeholder={t('Select duration')}
              onChange={(_, data) => {
                setPhaseOneData({
                  ...phaseOneData,
                  months: data.value as string
                })
                setPhaseTwoData({
                  ...phaseTwoData,
                  //@ts-ignore
                  months: 12 - parseInt(data.value)
                })
              }}
              value={phaseOneData.months}
              options={monthsArray.map(month => ({ value: month.key, text: month.label }))}
            />
          </Form.Group>
        </Form>
      </div>
      <div className='row-phase'>
        <div className='title'>
          <label>{t('Phase 2')}</label>
          <Divider className='thicker-divider' />
        </div>
        <Form>
          <Form.Group widths={'equal'}>
            <Form.Input
              label={t('Name')}
              placeholder={t('Enter phase 2 name')}
              onChange={(_, data) => {
                setPhaseTwoData({
                  ...phaseTwoData,
                  name: data.value
                })
              }}
              value={phaseTwoData.name}
            />
            <Form.Select
              label={t('Duration')}
              selectOnBlur={false}
              selection
              scrolling
              placeholder={t('Select duration')}
              onChange={(_, data) => {
                setPhaseTwoData({
                  ...phaseTwoData,
                  months: data.value as string
                })
                setPhaseOneData({
                  ...phaseOneData,
                  //@ts-ignore
                  months: 12 - parseInt(data.value)
                })
              }}
              value={phaseTwoData.months}
              options={monthsArray.map(month => ({ value: month.key, text: month.label }))}
            />
          </Form.Group>
        </Form>
      </div>
    </PhaseContentWrapper>
  }

  function handleSubmitPhases() {
    setValue('feedingPhases', [
      { ...phaseOneData },
      { ...phaseTwoData }
    ])
    setPhaseOneData(defaultPhaseValue)
    setPhaseTwoData({ ...defaultPhaseValue, order: 2 })
    handleClose(true)
  }

  function renderPhaseHeader() {
    return <Message info style={{ textAlign: 'center', borderRadius: 5 }}>
      <div>
        {t('Define the names of the two rations here (e.g. winter ration and summer ration) and determine the associated duration in months. \n\
        You can enter the quantity in the next step.')}
      </div>
    </Message>
  }

  return <Dialog
    isDialogOpen={isModalOpen}
    handleClose={() => {
      setPhaseOneData(defaultPhaseValue)
      setPhaseTwoData({ ...defaultPhaseValue, order: 2 })
      handleClose()
    }}
    textClose={t('Cancel')}
    textSubmit={t('Add')}
    noScrollingContent
    textHeader={t('Phase designation')}
    textContent={<div>
      {renderPhaseHeader()}
      {renderPhaseContent()}
    </div>}
    disableSubmit={[...Object.values(phaseOneData), ...Object.values(phaseTwoData)].find(value => value === '') !== undefined}
    handleSubmit={() => handleSubmitPhases()}

  />
}
export default CreatePhasesModal